import { render } from "./3ContactBanner.vue?vue&type=template&id=2dd3d703&scoped=true"
import script from "./3ContactBanner.vue?vue&type=script&lang=js"
export * from "./3ContactBanner.vue?vue&type=script&lang=js"

import "./3ContactBanner.vue?vue&type=style&index=0&id=2dd3d703&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd3d703"]])

export default __exports__